// Validates the value coming from a native <input type="date"> for a tenancy
// contract expiry date. The input's value is always "YYYY-MM-DD", but in
// Arabic/RTL the native date picker makes it easy to commit a short year
// (e.g. "0027-05-31" instead of "2027-05-31"), which then reaches the backend
// as "0027-05-31T00:00:00". This rejects anything without a real 4-digit year
// that isn't a valid, non-past date (the input already enforces min=today
// visually, but the raw value can still bypass it).
function isValidTenancyDate(value?: string | null): boolean {
  if (!value) return false;

  // type="date" always returns "YYYY-MM-DD"
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);

  // Reject short/padded years like 0027, 0099, etc.
  if (year < 1000) return false;

  // Build the date from parts (local time) and confirm it didn't roll over,
  // which rejects impossible dates like 2027-02-30.
  const selected = new Date(year, month - 1, day);
  if (
    selected.getFullYear() !== year ||
    selected.getMonth() !== month - 1 ||
    selected.getDate() !== day
  ) {
    return false;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Expiry date must not be in the past.
  return selected >= today;
}

export default isValidTenancyDate;
